import ChevronRight from "./chevron-right.svg";
import ChevronRightGreen from "./chevron-right-green.svg";
import Clock from "./clock.svg";
import Gift from "./gift.svg";
import Logo from "./logo.svg";
import LogoWithText from "./logo-with-text.svg";
import LogoWithTextBlack from "./logo-with-text-black.svg";
import LogoBlack from "./logo-black.svg";
import LogoGreen from "./logo-green.svg";
import Plus from "./plus.svg";
import Profile from "./profile.svg";
import Shield from "./shield.svg";
import ShieldCheck from "./shield-check.svg";
import Sad from "./sad.svg";
import ProfileUser from "./profile-user.svg";
import ProfileUserInactive from "./profile-user-inactive.svg";
import ProfilePhone from "./profile_phone.svg";
import Calling from "./calling_static.svg";
import CloseRed from "./close-red.svg";
import Close from "./close.svg";
import ReturnBrown from "./return-brown.svg";
import Gmail from "./gmail.svg";
import HandGive from "./hand-give.svg";
import HandGiveActive from "./hand-give-active.svg";
import Notebook from "./notebook.svg";
import NotebookActive from "./notebook-active.svg";
import ProfileBank from "./profile-bank.svg";
import NoProof from "./no-proof.svg";
import CheckCircle from "./check-circle.svg";
import FacebookButton from "./facebook_button.svg";
import TwitterButton from "./twitter_button.svg";
import InstagramButton from "./instagram_button.svg";
import MessengerButton from "./messenger_button.svg";
import SearchCircle from "./search-circle.svg";
import MoneyCircle from "./money-circle.svg";
import MoneyCircleActive from "./money-circle-active.svg";
import Mail from "./mail.svg";
import Bank from "./bank.svg";
import Lock from "./lock.svg";
import SmileFace from "./smile-face.svg";
import Check from "./check.svg";
import CheckWhite from "./check-white.svg";
import NoEmail from "./no-email.svg";
import BankBlack from "./bank-black.svg";
import LogoPlaid from "./logo-plaid.svg";
import NoProofPaper from "./no_proof_paper.svg";
import House from "./house.svg";
import Edit from "./edit.svg";
import PlusCircle from "./plus-circle.svg";
import OpenLink from "./open-link.svg";
import SearchCircleGray from "./search-circle-gray.svg";
import ClockGray from "./clock-gray.svg";
import CheckCircleRed from "./check-circle-red.svg";
import ArrowCircleInner from "./arrow-circle-inner.svg";
import OfferCheck from "./ic_check_offer.svg";
import Download from "./download.svg";
import BillNegotiator from "./bill-negotiator.svg";
import EarnRewards from "./earn-rewards.svg";
import Leaves from "./leaves.svg";
import Upload from "./upload.svg";
import Apple from "./apple.svg";
import Spotify from "./spotify.svg";
import AppleCircle from "./apple-circle.svg";
import SpotifyCircle from "./spotify-circle.svg";
import StarOutlineThin from "./star-outline-thin.svg";
import Cursor from "./cursor.svg";
import Scribble from "./scribble.svg";
import CompanyApple from "./company-apple.svg";
import CompanyInstagram from "./company-instagram.svg";
import CompanyGoogle from "./company-google.svg";
import CompanyFacebook from "./company-facebook.svg";
import CompanyWordpress from "./company-wordpress.svg";
import CompanyTiktok from "./company-tiktok.svg";
import EditLine from "./edit-line.svg";
import LinkConnect from "./link-icon.svg";
const Icons = {
  Logo,
  LogoBlack,
  LogoGreen,
  LogoWithText,
  LogoWithTextBlack,
  Gift,
  Clock,
  ChevronRight,
  ChevronRightGreen,
  Plus,
  PlusCircle,
  Shield,
  Profile,
  Sad,
  ProfileUser,
  ProfileUserInactive,
  ProfilePhone,
  Calling,
  CloseRed,
  Close,
  ReturnBrown,
  Gmail,
  HandGive,
  HandGiveActive,
  Notebook,
  NotebookActive,
  ProfileBank,
  Bank,
  BankBlack,
  NoProof,
  CheckCircle,
  FacebookButton,
  TwitterButton,
  InstagramButton,
  MessengerButton,
  SearchCircle,
  SearchCircleGray,
  MoneyCircle,
  MoneyCircleActive,
  Mail,
  ShieldCheck,
  Lock,
  SmileFace,
  Check,
  CheckWhite,
  NoEmail,
  LogoPlaid,
  NoProofPaper,
  House,
  Edit,
  OpenLink,
  ClockGray,
  CheckCircleRed,
  ArrowCircleInner,
  OfferCheck,
  Download,
  BillNegotiator,
  EarnRewards,
  Leaves,
  Upload,
  Apple,
  Spotify,
  AppleCircle,
  SpotifyCircle,
  StarOutlineThin,
  Cursor,
  Scribble,
  CompanyApple,
  CompanyInstagram,
  CompanyGoogle,
  CompanyFacebook,
  CompanyWordpress,
  CompanyTiktok,
  EditLine,
  LinkConnect,
};

export default Icons;
